import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export const downloadAllocated_FWPDF = ({ reportData, selectedYear1 }) => {
  const doc = new jsPDF("landscape", "mm", "a4");

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const timestamp = new Date().toLocaleString();

  //=========================================
  // HEADER
  //=========================================
  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text("St. Haris High School", pageWidth / 2, 14, { align: "center", });

  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text(`Allocated Fee Waiver for ${selectedYear1} -  ${Number(selectedYear1) + 1}`, pageWidth / 2, 22, { align: "center", });

  doc.setDrawColor(180);
  doc.setLineWidth(0.5);
  doc.line(10, 26, pageWidth - 10, 26);

  let startY = 30;

  reportData.forEach((group, index) => {

    autoTable(doc, {

      startY,

      body: [

        [
          {
            content:
              `Fee Waiver : ${group.fw_desc}            Category : ${group.fw_catg}`,
            colSpan: 7,
            styles: {
              fillColor: [217, 237, 247],
              fontStyle: "bold",
              fontSize: 10
            }
          }
        ],

        [
          {
            content:
              `Budget : ${group.bgt_name}            Sub Budget : ${group.sub_bgt_name}`,
            colSpan: 7,
            styles: {
              fillColor: [217, 237, 247],
              fontStyle: "bold",
              fontSize: 10
            }
          }
        ],

        [
          "GR No",
          "Student Name",
          "Std/Div",
          "Remarks",
          "Status",
          "Waiver Amount",
          "Approved By"
        ],

        ...group.details.map(d => [

          d.gr_no,

          d.stud_name,

          d.std_div,

          d.fw_remarks,

          d.fw_status,

          Number(d.waiver_allocated_amt).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }),

          d.appr_by

        ])

      ],

      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 2,
        valign: "middle",
        textColor: [0, 0, 0]
      },

      columnStyles: {

        0: {
          cellWidth: 20
        },

        1: {
          cellWidth: 65
        },

        2: {
          cellWidth: 25
        },

        3: {
          cellWidth: 80
        },

        4: {
          cellWidth: 20
        },

        5: {
          cellWidth: 30,
          halign: "right"
        },

        6: {
          cellWidth: 40
        },


      },

      didParseCell: function (data) {

        // Header row
        if (data.row.index === 2) {

          data.cell.styles.fillColor = [230, 230, 230];
          data.cell.styles.fontStyle = "bold";

        }

        // Detail row colours
        if (data.row.index > 2) {

          const status = data.row.raw[4];

          if (status === "Approved") {

            data.cell.styles.fillColor = [169, 223, 191];

          }

          else if (status === "Assigned") {

            data.cell.styles.fillColor = [255, 243, 205];

          }

          else {

            data.cell.styles.fillColor = [248, 215, 218];

          }

        }

      },

      margin: {
        left: 10,
        right: 10
      }

    });

    startY = doc.lastAutoTable.finalY + 8;

    // New page if required
    if (startY > pageHeight - 35 && index < reportData.length - 1) {
      doc.addPage();
      startY = 20;
    }

  });

  //=========================================
  // FOOTER
  //=========================================

  const pages = doc.getNumberOfPages();

  for (let i = 1; i <= pages; i++) {

    doc.setPage(i);

    doc.setDrawColor(180);
    doc.line(10, pageHeight - 12, pageWidth - 10, pageHeight - 12);

    doc.setFontSize(8);
    doc.setTextColor(100);

    doc.text(
      'eSchool',
      10,
      pageHeight - 7
    );

    // Center
    doc.text(
      `Generated : ${timestamp}`,
      pageWidth / 2,
      pageHeight - 7,
      { align: "center" }
    );


    doc.text(
      `Page ${i} of ${pages}`,
      pageWidth - 10,
      pageHeight - 7,
      { align: "right" }
    );
  }

  doc.save("Allocated_Fee_Waiver.pdf");

};
